import './vendor/bootstrap';
import './select2.min.js';
import './app/forms';
import './app/homepage';
import './jquery.js';
import 'slick-carousel';
import './googlemap.js';